// olap-client/src/components/chat/SettingsTab.jsx
import React, { useContext, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';
import { sendTestPush, subscribeToPush, getNotificationStatus, unsubscribeFromPush } from '../../utils/pushNotifications';

const SettingsTab = observer(() => {
  const { user } = useContext(Context);
  const [permissionStatus, setPermissionStatus] = useState('default');
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    setPermissionStatus(getNotificationStatus());
    
    setIsStandalone(
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  }, []);

  const handleEnableNotifications = async () => {
    const status = getNotificationStatus();
    
    if (status === 'denied') {
      alert(
        '⚠️ Уведомления заблокированы в настройках браузера.\n\n' +
        'Чтобы включить:\n' +
        '1. Кликните на иконку 🔒 слева от адреса\n' +
        '2. Найдите "Уведомления"\n' +
        '3. Измените на "Разрешить"\n' +
        '4. Перезагрузите страницу'
      );
      return;
    }

    if (status === 'unsupported') {
      alert('❌ Ваш браузер не поддерживает push-уведомления');
      return;
    }

    const sub = await subscribeToPush();
    if (sub) {
      alert('✅ Подписка создана! Отправляем тест...');
      await sendTestPush();
      setPermissionStatus('granted');
    } else {
      alert('❌ Не удалось создать подписку.');
    }
  };

  const handleInstallApp = () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    
    if (isIOS && isSafari) {
      alert(
        '📱 Установка на iOS:\n\n' +
        '1. Нажмите кнопку "Поделиться" (⬆️)\n' +
        '2. Выберите "На экран Домашний"\n' +
        '3. Нажмите "Добавить"\n' +
        '4. Откройте приложение с домашнего экрана'
      );
    } else {
      alert(
        '💻 Установка приложения:\n\n' +
        'В браузере Chrome/Edge:\n' +
        '1. Кликните на иконку установки в адресной строке\n' +
        '2. Или: Меню → "Установить приложение"\n\n' +
        'После установки мессенджер будет работать как обычное приложение.'
      );
    }
  };

  // === НОВАЯ ФУНКЦИЯ: ВЫХОД ===
  const handleLogout = async () => {
    if (!window.confirm('Вы уверены, что хотите выйти?')) {
      return;
    }

    console.log('🚪 [Settings] Logging out...');

    // 1. Отписываемся от push ПЕРЕД очисткой токена
    await unsubscribeFromPush();

    // 2. Очищаем localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    // 3. Сбрасываем состояние
    user.setIsAuth(false);
    user.setUser({});

    // 4. Перезагружаем страницу
    window.location.href = '/';
  };

  const settingsItems = [
    { icon: '🔔', label: 'Уведомления и звуки' },
    { icon: '🔒', label: 'Конфиденциальность' },
    { icon: '📊', label: 'Данные и трафик' },
    { icon: '💬', label: 'Настройки чатов' },
    { icon: '📁', label: 'Папки' },
    { icon: '🌙', label: 'Оформление' },
    { icon: '🌐', label: 'Язык' },
  ];

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: '#ffffff'
    }}>
      <div style={{
        padding: '16px',
        borderBottom: '1px solid #e4e4e5',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        Настройки
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {/* Кнопка включения уведомлений */}
        <div
          onClick={handleEnableNotifications}
          style={{
            padding: '14px 16px',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            cursor: 'pointer',
            transition: 'background 0.2s',
            background: permissionStatus === 'granted' ? '#e8f5e9' : 'white'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#f4f4f5'}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = permissionStatus === 'granted' ? '#e8f5e9' : 'white';
          }}
        >
          <span style={{ fontSize: '20px' }}>
            {permissionStatus === 'granted' ? '✅' : 
             permissionStatus === 'denied' ? '🚫' : '🔔'}
          </span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '15px', fontWeight: '500' }}>
              {permissionStatus === 'granted' ? 'Уведомления включены' :
               permissionStatus === 'denied' ? 'Уведомления заблокированы' :
               'Включить уведомления'}
            </div>
            <div style={{ fontSize: '12px', color: '#707579', marginTop: '2px' }}>
              {permissionStatus === 'granted' ? 'Нажмите для тестирования' :
               permissionStatus === 'denied' ? 'Нажмите для инструкции' :
               'Получать push-уведомления'}
            </div>
          </div>
        </div>

        {/* Кнопка установки приложения */}
        {!isStandalone && (
          <div
            onClick={handleInstallApp}
            style={{
              padding: '14px 16px',
              borderBottom: '1px solid #f0f0f0',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f4f4f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
          >
            <span style={{ fontSize: '20px' }}>📱</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '15px', fontWeight: '500' }}>
                Установить приложение
              </div>
              <div style={{ fontSize: '12px', color: '#707579', marginTop: '2px' }}>
                Добавить на домашний экран
              </div>
            </div>
          </div>
        )}

        {/* Остальные настройки */}
        {settingsItems.map((item, idx) => (
          <div
            key={idx}
            style={{
              padding: '14px 16px',
              borderBottom: '1px solid #f0f0f0',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f4f4f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'white'} 
          >
            <span style={{ fontSize: '20px' }}>{item.icon}</span>
            <span style={{ fontSize: '15px' }}>{item.label}</span>
          </div>
        ))}

        {/* === КНОПКА ВЫХОДА === */}
        <div
          onClick={handleLogout}
          style={{
            padding: '14px 16px',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            cursor: 'pointer',
            transition: 'background 0.2s',
            marginTop: '20px',
            background: '#ffebee'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#ffcdd2'}
          onMouseLeave={(e) => e.currentTarget.style.background = '#ffebee'}
        >
          <span style={{ fontSize: '20px' }}>🚪</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '15px', fontWeight: '500', color: '#c62828' }}>
              Выйти из аккаунта
            </div>
            <div style={{ fontSize: '12px', color: '#707579', marginTop: '2px' }}>
              Push-уведомления будут отключены на этом устройстве
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SettingsTab;